import { Component, OnInit } from "@angular/core";
import { scrollToTop } from "src/app/helpers/helpers";
import { MetaService } from "src/app/services/meta.service";

@Component({
  selector: "app-for-brands",
  templateUrl: "./for-brands.component.html",
  styleUrls: ["./for-brands.component.scss"],
})
export class ForBrandsComponent implements OnInit {
  constructor(private metaService: MetaService) {}

  bizeGuvenenlerItems = [
    "eker.png",
    "eastmarine.png",
    "beltur.png",
    "aktaslar.png",
    "boost.png",
    "hummel.png",
    "artcafe.png",
    "kolektif.png",
    "buky.png",
    "peynircibaba.png",
    "itsbasic.png",
    "lucid.png",
    "kozza.png",
    "lastiktr.png",
    "someka.png",
    "quzucuk.png",
    "yasomi.png",
    "musichool.png",
    "sportive.png",
    "petinoks.png",
    "mugo.png",
    "leopar.png",
    "tatilimsensin.png",
    "pickhobi.png",
    "renksu.png",
    "muhiku.png",
    "dovimobilya.png",
    "cocoas.png",
    "teknokta.png",
    "kahvecom.png",
    "elbisebul.png",
  ];

  ngOnInit(): void {
    scrollToTop();

    this.metaService.set({
      title: "Markalar İçin - Bilgesin",
      description:
        "Bilgesin, yalnızca yenilikçi bir dijital araştırma ve içgörü çözümü sunmakla kalmaz; aynı zamanda markaların mevcut müşteri portföylerini genişletmelerine ve yeni hedef kitlelere etkili biçimde ulaşmalarına olanak tanır.",
    });
  }
}
